// قواميسُ الصفحات — كلُّ مجموعةٍ في ملفّها كي تُترجَم الصفحاتُ بالتوازي دون أن
// تتصادم في ملفٍّ واحد. القاموسُ الأساسيّ في ../i18n.ts يتقدّم عليها (translate).
import b1 from "./b1";
import b2 from "./b2";
import b3 from "./b3";
import b4 from "./b4";
import b5 from "./b5";
import b6 from "./b6";
import b7 from "./b7";
import b8 from "./b8";
import b9 from "./b9";
import b10 from "./b10";
import b11 from "./b11";
import b12 from "./b12";
import b13 from "./b13";
import b14 from "./b14";
import b15 from "./b15";
import b16 from "./b16";
import b17 from "./b17";
import b18 from "./b18";
import b19 from "./b19";
import b20 from "./b20";
import b21 from "./b21";

export const EN_PAGES: Record<string, string> = { ...b1, ...b2, ...b3, ...b4, ...b5, ...b6, ...b7, ...b8, ...b9, ...b10, ...b11, ...b12, ...b13, ...b14, ...b15, ...b16, ...b17, ...b18, ...b19, ...b20, ...b21 };
